import { render, staticRenderFns } from "./EcommerceForm.vue?vue&type=template&id=610954c0&scoped=true&"
import script from "./EcommerceForm.vue?vue&type=script&lang=js&"
export * from "./EcommerceForm.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceForm.vue?vue&type=style&index=0&id=610954c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610954c0",
  null
  
)

export default component.exports